<template>
    <iframe :src="src" frameborder="0" scrolling="yes" width="100%" height="100%"></iframe>
</template>
<script>
export default {
    data() {
        return {
            src: ''
        }
    },
    created() {
        this.src = `${this.FILE_PREVIEW_URL}/onlinePreview?url=(${encodeURIComponent(this.$route.query.src)})&fullfilename=${encodeURIComponent('win客户端访问samba服务手册 (7).txt')}`
    }
}
</script>